export const SimConstants = {
  /** Fixed simulation rate (ADR 0002). Changing it invalidates every golden file. */
  TicksPerSecond: 20,
  MaxEnemies: 512,
  MaxTowers: 128,
  /** Safety cap for headless runs: one hour of simulated time. */
  MaxTicksPerLevel: 20 * 3600,
} as const;
